export const SCREEN_WIDTH_BREAKPOINT: string = "768px";
